import React from 'react';
import bgStarBear from '@/assets/app/images/common/bottom/bg-star-bear.png';
import AppButton from '@/shared/components/ui/new/AppButton';

interface MissionSuccessDialogProps {
  /** 다이얼로그 제목. 생략 시 '미션 성공!' 사용 */
  title?: string;
  /** 중간 안내 메시지. <span> 등 HTML 태그를 사용해 강조 표시할 수 있음 */
  message: string;
  /** 획득한 별 포인트. 전달하지 않으면 포인트 안내 줄을 표시하지 않음 */
  points?: number;
  /** 상단 이미지. 생략 시 기본 starBear 이미지 사용 */
  image?: string;
  /** 확인 버튼 라벨. 생략 시 '확인' 사용 */
  confirmLabel?: string;
  onConfirm: () => void;
}

/**
 * 미션 성공 다이얼로그 (화면 중앙 팝업)
 * - 타이틀/메시지/포인트/이미지 표시 여부를 호출부에서 자유롭게 구성해 여러 화면에서 재사용한다
 */
export const MissionSuccessDialog: React.FC<MissionSuccessDialogProps> = ({
  title = '미션 성공!',
  message,
  points,
  image = bgStarBear,
  confirmLabel = '확인',
  onConfirm,
}) => {
  return (
    <div className="bg-white rounded-[24px] w-[85vw] max-w-[360px] px-6 pt-10 pb-6 text-center">
      <div className="flex justify-center mb-2">
        <img src={image} alt="미션 성공" style={{ maxHeight: 120 }} />
      </div>

      <h2 className="text-2xl font-extrabold mb-4 f-one-pop">{title}</h2>

      <p
        className={`text-[15px] ${points !== undefined ? 'mb-2' : 'mb-6'}`}
        dangerouslySetInnerHTML={{ __html: message }}
      />

      {points !== undefined && (
        <p className="text-[15px] mb-6">
          별 포인트 <span style={{ color: '#1AAEFF', fontWeight: 700 }}>{points}개</span>를
          획득했어요
        </p>
      )}

      <AppButton onConfirm={onConfirm} message={confirmLabel} style={{ fontSize: 20 }} />
    </div>
  );
};

export default MissionSuccessDialog;
